import { PivotPanel, PivotEngine } from "@grapecity/wijmo.olap";
import { Control } from "@grapecity/wijmo";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import "./Cube.css";
import FolderStructure from "./FolderStructure";
import { useEffect, useRef } from "react";
import "src/assets/css/explorer.css";
import PivotComponents from "./Components/PivotComponents";
import { customControlTemplate } from "./customControlTemplate";

const Cube = (props) => {
  const {
    data,
    columns,
    title,
    handleNavigate,
    explorerDataKey,
    treeItems,
    hideStatistics,
  } = props;

  const dateBindings = columns
    .filter((obj) => obj.format === "date")
    .map((obj) => obj.binding);

  PivotPanel.controlTemplate = customControlTemplate;
  const headersArray = [];
  const ngPanel = new PivotEngine({
    itemsSource: data?.map((item) => {
      dateBindings?.forEach((binding) => {
        item[binding] = new Date(item[binding]);
      });
      if (item.Season) item.Season = item.Season.toString();
      if (item.ProtocolNumber)
        item.ProtocolNumber = item.ProtocolNumber.toString();

      return item;
    }),
    fields: columns?.map((c, index) => {
      if (headersArray?.includes(c?.header))
        return { binding: c?.binding, header: `${c?.header}${index}` };
      headersArray.push(c.header);
      return { binding: c?.binding, header: `${c?.header}` };
    }),
  });
  const pivotRef = useRef();

  return (
    <Grid
      container
      spacing={2}
      sx={{ maxHeight: "90%", overflowY: "auto" }}
      alignItems="stretch"
    >
      {columns?.length > 0 && (
        <PivotComponents
          ngPanel={ngPanel}
          columns={columns}
          ref={pivotRef}
          title={title}
          handleNavigate={handleNavigate}
          explorerDataKey={explorerDataKey}
          hideStatistics={hideStatistics}
          treeItems={treeItems}
        />
      )}
    </Grid>
  );
};

export default Cube;
